<template>
  <div class="tree">
      <node-tree :parentId="ParentDirectory" :node="treeData"></node-tree>
  </div>
</template>
<script>
import NodeTree from "./NodeTree";
export default {
  props: {
    treeData: Array,
    ParentDirectory:String
  },
  components: {
    NodeTree
  },
  methods:{
  },
};
</script>
<style>
.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>